import tw from 'twin.macro'
import { styled } from '@mui/material/styles'
import SelectMUI from '@mui/material/Select'
import FormControlMUI from '@mui/material/FormControl'

export const FormControl = styled(FormControlMUI)`
  & {
    ${tw`w-full`}
  }

  & label {
    ${tw`leading-none`}
  }

  & label.Mui-focused {
    ${tw`text-primary-600`}
  }
`

export const Select: any = styled(SelectMUI)`
  & {
    ${tw`w-full h-11 rounded-lg`}
  }

  &.Mui-focused fieldset {
    ${tw`!border-primary-600`}
  }
`
